module.exports = __webpack_public_path__ + "img/4.35dd8b0e.svg";